module.exports = "/assets/7fdd21d249d7f3b65b1c68770f6fd206.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CY.png
// module id = 1282
// module chunks = 0